module.exports = __webpack_public_path__ + "static/media/support-icon.f6a0d2af.svg";